import { Deserializer } from 'jsonapi-serializer';
import { z } from 'zod';
import { request, useQuery } from '@applyboard/ui-utils';
var BusinessCertificateSchema = z.object({
  id: z.string(),
  fileName: z.string(),
  fileSize: z.number(),
  contentType: z.string(),
  urlOriginal: z.string()
});
export function useBusinessCertificate(businessCertificateId) {
  var _useQuery = useQuery(['businessCertificate', businessCertificateId, {
      pkg: 'ab-rpj'
    }], function () {
      return request("/api/business_certificate/".concat(businessCertificateId), {
        schema: BusinessCertificateSchema,
        deserializer: new Deserializer({
          keyForAttribute: 'camelCase'
        })
      });
    }),
    isFetching = _useQuery.isFetching,
    isLoading = _useQuery.isLoading,
    data = _useQuery.data,
    error = _useQuery.error;
  return {
    isFetchingBusinessCertificate: isFetching,
    isLoadingBusinessCertificate: isLoading,
    businessCertificateError: error,
    businessCertificate: data
  };
}